import React from 'react';

import PlayGlyph from '@rover/icons/svg/play-glyph.svg';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import { withOpacityRgba } from '@rover/kibble/utils';

import { PLAY_BADGE_OPACITY, PLAY_BADGE_SIZE } from './constants';

const PLAY_BADGE_SIZE_PX = `${PLAY_BADGE_SIZE}px`;

/** The play affordance drawn over a video's thumbnail. */
const GalleryPlayBadge = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex
      position="absolute"
      top="0"
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      data-testid="gallery-play-icon"
      // The badge sits over the tile's own click target, so it has to
      // let presses through rather than swallow them.
      sx={{ pointerEvents: 'none' }}
    >
      <Flex
        width={PLAY_BADGE_SIZE_PX}
        height={PLAY_BADGE_SIZE_PX}
        borderRadius="round"
        justifyContent="center"
        alignItems="center"
        sx={{ backgroundColor: withOpacityRgba(theme.textColor.primary, PLAY_BADGE_OPACITY) }}
      >
        <PlayGlyph
          height={PLAY_BADGE_SIZE_PX}
          width={PLAY_BADGE_SIZE_PX}
          fill={theme.textColor.primary_inverse}
        />
      </Flex>
    </Flex>
  );
};

export default GalleryPlayBadge;
